export default {
    showVariationsModal: {
        copy: 'Kopioi',
        contentVariation: 'Sisältömuunnelma',
        chosenContent: 'Valittu sisältö',
        chosenContentPlaceholder: 'Ole hyvä ja syötä',
        continue: 'Jatka',
        generateNewContent: 'Tuota uutta sisältöä',
        type: 'Tyyppi:',
        contentTitle: 'Otsikko:',
        descriptionLabel: 'Kuvaus:',
        keywordsLabel: 'Avainsanat:',
        writingTone: 'Kirjoitustyyli:',
        context: 'Konteksti:',
        cancel: 'Peruuttaa',
        emailBuilderTooltip: 'Custom values for sender and recipient is added in the content.',
    },
};
